module.exports = __webpack_public_path__ + "img/case16.d9244540.jpg";